import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            <span className="text-foreground-400">「</span>
            读者口碑
            <span className="text-foreground-400">」</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            听听韩漫爱好者们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t) => (
            <article key={t.id} className="bg-background-100 border border-background-200/70 rounded-lg p-6 flex flex-col">
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
              <blockquote className="flex-1">
                <p className="text-sm text-foreground-700 leading-relaxed italic">
                  &ldquo;{t.content}&rdquo;
                </p>
              </blockquote>
              <div className="flex items-center gap-3 mt-6 pt-4 border-t border-background-200/70">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}